import {
  TASK_SEARCH_HOTEL,
  TASK_SEARCH_HOTEL_LIST,
  TASK_SEARCH_HOTEL_TERMINATE,
  TASK_SEARCH_HOTEL_PREPARE,
  SEARCH_HOTEL_PARAMS,
  SEARCH_HOTEL_CLEAR_RESULT
} from "../../util/mutationTypes";

import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      taskHotelSearchId: state => state.SearchHotelStorage.taskHotelSearchId,
      metaHotelsFeatch: state => state.SearchHotelStorage.metaHotelsFeatch,
      hotelsFound: state => state.SearchHotelStorage.hotelsFound,
      taskSearchHotelDelay: state => state.SettingStorage.taskSearchHotelDelay,
      taskSearchHotelLimitCounter: state =>
        state.SettingStorage.taskSearchHotelLimitCounter,
      taskSearchHotelMaxCounter: state =>
        state.SettingStorage.taskSearchHotelMaxCounter
    })
  },
  data() {
    return {
      taskSearchHotelCounter: 0,
      taskSearchHotelPrepareUsed: false,
      timerId: 0
    };
  },
  methods: {
    async taskHotelSearchBegin(lang, searchParams) {
      return this.$store.dispatch(TASK_SEARCH_HOTEL, { lang, searchParams });
    },
    async featchTaskHotelSearch(taskId, lastCount) {
      return this.$store.dispatch(TASK_SEARCH_HOTEL_LIST, {
        taskId,
        lastCount
      });
    },
    async taskHotelSearchTerminate(taskId) {
      return this.$store.dispatch(TASK_SEARCH_HOTEL_TERMINATE, taskId);
    },
    async taskHotelSearchPrepare() {
      this.$store.commit(TASK_SEARCH_HOTEL_PREPARE);
    },
    async terminateSearch() {
      this.stopTimer();
      this.taskHotelSearchStop();
      if (this.taskHotelSearchId) {
        this.taskHotelSearchTerminate(this.taskHotelSearchId);
        this.$store.commit(TASK_SEARCH_HOTEL, 0);
      }
    },
    taskHotelSearchStop() {
      this.taskSearchHotelCounter = 0;
    },
    stopTimer() {
      if (this.timerId !== 0) {
        clearTimeout(this.timerId);
        this.timerId = 0;
      }
    },
    async featchTaskHotelSearchLimit() {
      // Количество запросов ограничено
      this.featchTaskHotelSearch(
        this.taskHotelSearchId,
        this.metaHotelsFeatch.lastCount
      )
        .then(() => {
          if (
            this.metaHotelsFeatch.eof ||
            (this.taskSearchHotelCounter >= this.taskSearchHotelLimitCounter &&
              this.hotelsFound.length)
          ) {
            if (!this.taskSearchHotelPrepareUsed) {
              this.taskHotelSearchPrepare();
              this.taskSearchHotelPrepareUsed = true;
            }

            if (this.metaHotelsFeatch.eof || this.taskHotelSearchId === 0) {
              this.terminateSearch();
            } else {
              this.setExecuteTimer(this.featchTaskHotelSearchLimit);
            }
          } else {
            if (this.taskHotelSearchId !== 0) {
              this.setExecuteTimer(this.featchTaskHotelSearchLimit);
            }
          }
        })
        .catch(() => {
          this.terminateSearch();
        });

      if (this.taskSearchHotelCounter >= this.taskSearchHotelMaxCounter) {
        this.terminateSearch();
      }

      this.taskSearchHotelCounter++;
    },
    async featchTaskHotelSearchUnLimit() {
      // Количество запросов не ограничено
      if (this.taskHotelSearchId === 0) {
        return false;
      }

      this.featchTaskHotelSearch(
        this.taskHotelSearchId,
        this.metaHotelsFeatch.lastCount
      )
        .then(() => {
          if (!this.taskSearchHotelPrepareUsed) {
            this.taskHotelSearchPrepare();
          }

          if (this.metaHotelsFeatch.eof || this.taskHotelSearchId === 0) {
            this.terminateSearch();
          } else {
            this.setExecuteTimer(this.featchTaskHotelSearchUnLimit);
          }
        })
        .catch(() => {
          this.terminateSearch();
        });

      if (this.taskSearchHotelCounter >= this.taskSearchHotelMaxCounter) {
        this.terminateSearch();
      }

      this.taskSearchHotelCounter++;
    },
    async setExecuteTimer(handler) {
      this.timerId = setTimeout(handler, this.taskSearchHotelDelay);
    },
    clearSearchResult() {
      this.$store.commit(SEARCH_HOTEL_CLEAR_RESULT);
    },
    async startSearchFrom(lang, searchParams, handler) {
      this.clearSearchResult();
      await this.terminateSearch();
      this.$store.commit(SEARCH_HOTEL_PARAMS, searchParams);
      this.taskSearchHotelPrepareUsed = false;
      this.taskSearchHotelCounter = 0;

      this.taskHotelSearchBegin(lang, searchParams).then(() => {
        this.setExecuteTimer(handler);
      });
    },
    async startSearchFromMap(lang, searchParams) {
      this.startSearchFrom(
        lang,
        searchParams,
        this.featchTaskHotelSearchUnLimit
      );
    },
    async startSearchFromFirstStep(lang, searchParams) {
      this.startSearchFrom(lang, searchParams, this.featchTaskHotelSearchLimit);
    },
    async showSearchFromFirstStep() {
      this.taskHotelSearchPrepare();
      this.taskSearchHotelPrepareUsed = true;
    }
  }
};
